import { type FC, useState } from "react";
import { type Work } from "../WorkSelector/useWorksFilter";
import { WorkSelector } from "../WorkSelector";

type Props = {
  isSp: boolean;
  totalWorksCount: number;
  defaultWorkId: string | undefined;
  works: readonly Work[];
  clientScoutsPath: string;
  returnPath: string;
  isDescriptionVisible?: boolean;
  recommendText?: string;
  formNameBase: string;
};

export const WorkIdParamChanger: FC<Props> = ({
  isSp,
  totalWorksCount,
  works,
  defaultWorkId,
  clientScoutsPath,
  returnPath,
  isDescriptionVisible,
  recommendText,
  formNameBase,
}) => {
  const [currentWorkId, setCurrentWorkId] = useState<string | undefined>(defaultWorkId);

  // 求人の選択内容を検索結果のおすすめ表記などに使用するため、求人選択後パラメータにwork_idを反映しリロードする
  const handleWorkChange = (workId: string | undefined) => {
    setCurrentWorkId(workId);

    // 求人選択を解除したらパラメータなしのスカウト一覧画面に画面遷移する
    if (!workId) {
      window.location.href = returnPath;
      return;
    }

    const separator = clientScoutsPath.includes("?") ? "&" : "?";
    const url = `${clientScoutsPath}${separator}work_id=${workId || "all"}`;
    window.location.href = url;
  };

  return (
    <>
      <WorkSelector
        isSp={isSp}
        totalWorksCount={totalWorksCount}
        currentWorkId={currentWorkId}
        onWorkChange={handleWorkChange}
        works={works}
        isAutoSelectorVisible={false}
        hasBorder={!isSp}
        isDescriptionVisible={isDescriptionVisible}
        recommendText={recommendText}
        hasMatchingJobs={false}
      />
      <input
        type="hidden"
        id="js-hidden-work-id"
        name={`${formNameBase}[work_id]`}
        value={currentWorkId || ""}
      />
    </>
  );
};
